import IBAN from 'iban'

const SHORTEST_IBAN_LENGTH = 15

export const electronicIban = accountNumber =>
  String(accountNumber || '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase()

export const shouldShowBankAccountError = (accountNumber, valid) => {
  if (valid) return false

  const stripped = electronicIban(accountNumber)
  const spec = IBAN.countries[stripped.slice(0, 2)]
  const requiredLength = spec ? spec.length : SHORTEST_IBAN_LENGTH

  return stripped.length >= requiredLength
}
